module.exports = __webpack_public_path__ + "img/img-900b7c.jpg";